import { useState } from "react";

export default function PortfolioCard(props: {
  imgUrl: string;
  summary: string;
  role: string;
  siteUrl: string;
  skills: string[];
}) {
  const [showData, setShowData] = useState(false);
  return (
    <div className="w-full shadow-card-dark animate__animated animate__fadeInUp rounded-xl overflow-hidden border border-white/20">
      <div className="w-full relative h-[32px] bg-gradient-to-r from-dark-bg-800 to-dark-bg-700 text-gray-300 flex items-center justify-center border-b border-white/20">
        <h1 className="text-sm font-inter font-medium">{props.siteUrl}</h1>
        <i
          className="w-[12px] h-[12px] bg-red-500 rounded-full absolute top-[10px] left-[12px]
        before:w-[12px] before:h-[12px] before:bg-yellow-500 before:rounded-full before:absolute before:top-[0px] before:left-[16px]
        after:w-[12px] after:h-[12px] after:bg-green-500 after:rounded-full after:absolute after:top-[0px] after:left-[32px]"
        ></i>
      </div>
      <div
        className="relative w-full cursor-pointer min-h-[200px]"
        id="img"
        onMouseEnter={() => setShowData(true)}
        onMouseLeave={() => setShowData(false)}
      >
        <img
          src={props.imgUrl}
          className="object-cover w-full max-h-[200px] h-full"
          alt=""
        />
        <div
          id="data"
          className={`absolute bg-gradient-to-br from-dark-bg-900/95 to-dark-bg-950/95 backdrop-blur-sm transition-all duration-500 top-0 flex items-center justify-center ${
            showData ? "w-full h-full opacity-100" : "h-0 opacity-0"
          }`}
        >
          <div
            className={
              showData
                ? "relative flex flex-col justify-center items-center gap-2 px-1 text-center"
                : "hidden"
            }
          >
            <p className="text-sm font-bold text-white font-inter">{props.role}</p>
            <p className="text-xs text-gray-300 font-inter leading-relaxed">{props.summary}</p>
            <div className="flex flex-wrap gap-1 mt-2 text-gray-400">
              {props.skills.map((item, key) => (
                <span className="text-xs bg-dark-bg-800/50 px-2 py-1 rounded-md border border-white/20" key={key}>
                  {item}
                </span>
              ))}
            </div>
            <a
              href={props.siteUrl}
              target="_blank"
              rel="referrer"
              className={`px-4 py-2 w-[120px] flex items-center justify-center font-semibold text-white uppercase bg-gradient-to-r from-accent-600 to-purple-accent-600 rounded-lg text-[.6em] cursor-pointer hover:from-accent-500 hover:to-purple-accent-500 duration-300 transition-all hover:shadow-glow-purple
          `}
            >
              View Site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
